/*
 * Copyright (c) 2024. Dave van Rijn Development
 */

import {ControlVariant, ThemeProvider} from '@dvrd/dvr-controls';
import React, {PropsWithChildren, useState} from 'react';
import {ChangeContextConfig, ContextShape} from '../../util/interfaces';
import {ORANGE_VUURVOGEL} from "../../util/constants";

const defaultContext: ContextShape = {
    userContext: {
        user: null,
    },
    theme: {
        baseColor: ORANGE_VUURVOGEL,
        contrastColor: '#efefef',
        controlVariant: ControlVariant.SIMPLE,
    },
    calendarOnly: false,
    onChangeContext: () => {
    },
};

export const AppContext = React.createContext(defaultContext);

export default function AppContextProvider(props: PropsWithChildren<{}>) {
    const calendarOnly = new URLSearchParams(location.search).has('calendar');
    const [context, setContext] = useState<ContextShape>({...defaultContext, calendarOnly, onChangeContext});

    function onChangeContext(changes: ChangeContextConfig, callback?: VoidFunction) {
        const {user, calendarOnly} = changes;
        const _context = {...context};
        if (user !== undefined) _context.userContext.user = user;
        if (calendarOnly !== undefined) _context.calendarOnly = calendarOnly;
        setContext(_context);
        if (callback) window.setTimeout(callback);
    }

    return (
        <AppContext.Provider value={context}>
            <ThemeProvider theme={context.theme}>
                {props.children}
            </ThemeProvider>
        </AppContext.Provider>
    )
}

AppContextProvider.displayName = 'AppContextProvider';